import type { ReactNode } from 'react'

import { cn } from '@/components/ui/utils'

/**
 * A 16:9 box, as large as fits in the space it is given, centred. The annotation canvas reads its
 * `<svg>` box as the picture (`clientToPct`, the zoom / pan transform and the hit tolerances all
 * take the box width as 100 % and the height as 16:9 of it), so the svg must never be another
 * shape: in a taller box the picture was letterboxed (`preserveAspectRatio="meet"`) while clicks
 * were still read against the whole box — the top edge of a beach read as 25 % down, and every
 * point landed in the wrong place.
 *
 * The parent must have a size of its own (`relative` with a height): the box is absolutely
 * placed and sized with container units.
 */
export function FitPicture({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('absolute inset-0 grid place-items-center overflow-hidden', className)} style={{ containerType: 'size' }}>
      <div className="relative" style={{ width: 'min(100cqw, calc(100cqh * 16 / 9))', aspectRatio: '16 / 9' }} data-testid="fit-picture">
        {children}
      </div>
    </div>
  )
}
